import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { RecordingRulesFormValues } from "src/models/RecordingRules.model";
import { useAddRecordingRulesMutation } from "src/services/RecordingRulesServices";
import { showToast } from "src/utils/showToaster";
import { array, date, object } from "yup";
import RecordingRulesForm from "../Layout/RecordingRulesForm";
import { formatedDateTimeIntoIst } from "src/utils/formUtils/dateTimeFormate";

type Props = {
  onClose: () => void;
};

const AddRecordingRulesFormWrapper = ({ onClose }: Props) => {
  const [addRecordingRules] = useAddRecordingRulesMutation();

  // Form Initial Values
  const initialValues: RecordingRulesFormValues = {
    batchId: "",
    studentIds: "",
    startDate: null,
    endDate: null,
    radio: "",
    always: true,
  };

  // Validation Schema
  const validationSchema = object().shape({
    batchId: object().required("Please Select batch"),
    studentIds: array().required("Please Select batch"),
    startDate: date()
      .test("startDate", "Please Select startDate", function (value) {
        const { always } = this.parent;
        return always || value;
      })
      .nullable(),
    endDate: date()
      .test("endDate", "Please SelectendDate", function (value) {
        const { always } = this.parent;
        return always || value;
      })
      .nullable(),
  });

  // Handle Submit
  const handleSubmit = (
    values: RecordingRulesFormValues,
    { setSubmitting, resetForm }: FormikHelpers<RecordingRulesFormValues>
  ) => {
    const formattedValues = {
      // batchId: values?.batchId?._id,
      // studentIds: values?.studentIds?.map((student: any) => student?.value),
      // allowedDate: {
      //   startDate:
      //     values?.radio === "ALLOWLED"
      //       ? values?.always
      //         ? "*"
      //         : values?.startDate
      //       : null,
      //   endDate:
      //     values?.radio === "ALLOWLED"
      //       ? values?.always
      //         ? "*"
      //         : values?.endDate
      //       : null,
      // },
      // deniedDate: {
      //   startDate:
      //     values?.radio === "DENIED"
      //       ? values?.always
      //         ? "*"
      //         : values?.startDate
      //       : null,
      //   endDate:
      //     values?.radio === "DENIED"
      //       ? values?.always
      //         ? "*"
      //         : values?.endDate
      //       : null,
      // },
      // priority: values?.priority,
      status: values?.radio,
      startDate: values?.startDate
        ? formatedDateTimeIntoIst(values?.startDate, "YYYY-MM-DD")
        : "*",
      endDate: values?.endDate
        ? formatedDateTimeIntoIst(values?.endDate, "YYYY-MM-DD")
        : "*",
      batchId: values?.batchId?._id,
      studentIds: values?.studentIds?.map((student: any) => student?.value),
      priority: values?.radio === "DENIED" ? 2 : 1,
    };

    addRecordingRules(formattedValues).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="sm" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <RecordingRulesForm formikProps={formikProps} onClose={onClose} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddRecordingRulesFormWrapper;
